import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import GLOBAL_STYLES from '../styles'
import { getShift, rangesOverlap, cmp } from '../helpers/misc';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  machineData: state.app.machineData,
  locatorFilter: state.app.locatorFilter,
  locationData: state.app.locationData,
});

const OperatorModal = props => {
  const {
    colorScheme,
    machineData,
    locatorFilter,
    locationData,
    show,
    onHide,
  } = props;
  const [curShiftOperators, setCurShiftOperators] = useState([]);
  const [nextShiftOperators, setNextShiftOperators] = useState([]);
  const [nextNextShiftOperators, setNextNextShiftOperators] = useState([]);
  const [nextNextNextShiftOperators, setNextNextNextShiftOperators] = useState([]);
  const [curShiftTitle, setCurShiftTitle] = useState('THIS SHIFT');
  const [nextShiftTitle, setNextShiftTitle] = useState('NEXT SHIFT');
  const [nextNextShiftTitle, setNextNextShiftTitle] = useState('NEXT NEXT SHIFT');
  const [nextNextNextShiftTitle, setNextNextNextShiftTitle] = useState('NEXT NEXT NEXT SHIFT');
  
  
  useEffect(() => {
    if(!show) return;
    const locationObj = locationData ? locationData.get(locatorFilter) : null;
    const filteredMachineData = machineData ?
      machineData.filter(machineObj => locatorFilter === 'ALL' || machineObj.machineLocator === locatorFilter) :
      null;
    const scheduledJobs = filteredMachineData.map(machineObj => machineObj.schedule).flat();
    const jobData = filteredMachineData.map(machineData => machineData.jobs).flat();
    
    const now = Date.now();
    const currentShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes) : null;
    const nextShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes, 1) : null;
    const nextNextShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes, 2) : null;
    const nextNextNextShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes, 3) : null;
    const currentShiftRunning = scheduledJobs
      .filter(scheduleObj => !scheduleObj.isStoppage &&
        rangesOverlap(currentShiftData.startTime, currentShiftData.endTime, scheduleObj.startTime, scheduleObj.endTime) &&
        (scheduleObj.shifts == null || scheduleObj.shifts.some(o => o.enabled && o.name === currentShiftData.shiftName)))
      .map(scheduleObj => {
        const jobs = jobData.find(jobArr => jobArr.some(o => scheduleObj.jobNumbers.includes(o.jobNumber)));
        scheduleObj.requiredOperators = jobs && jobs[0].requiredOperators ? jobs[0].requiredOperators : 0;
        return scheduleObj;
      });
    const nextShiftRunning = scheduledJobs
      .filter(scheduleObj => !scheduleObj.isStoppage &&
        rangesOverlap(nextShiftData.startTime, nextShiftData.endTime, scheduleObj.startTime, scheduleObj.endTime) &&
        (scheduleObj.shifts == null || scheduleObj.shifts.some(o => o.enabled && o.name === nextShiftData.shiftName)))
      .map(scheduleObj => {
        const jobs = jobData.find(jobArr => jobArr.some(o => scheduleObj.jobNumbers.includes(o.jobNumber)));
        scheduleObj.requiredOperators = jobs && jobs[0].requiredOperators ? jobs[0].requiredOperators : 0;
        return scheduleObj;
      });
    const nextNextShiftRunning = scheduledJobs
      .filter(scheduleObj => !scheduleObj.isStoppage &&
        rangesOverlap(nextNextShiftData.startTime, nextNextShiftData.endTime, scheduleObj.startTime, scheduleObj.endTime) &&
        (scheduleObj.shifts == null || scheduleObj.shifts.some(o => o.enabled && o.name === nextNextShiftData.shiftName)))
      .map(scheduleObj => {
        const jobs = jobData.find(jobArr => jobArr.some(o => scheduleObj.jobNumbers.includes(o.jobNumber)));
        scheduleObj.requiredOperators = jobs && jobs[0].requiredOperators ? jobs[0].requiredOperators : 0;
        return scheduleObj;
      });
    const nextNextNextShiftRunning = scheduledJobs
      .filter(scheduleObj => !scheduleObj.isStoppage &&
        rangesOverlap(nextNextNextShiftData.startTime, nextNextNextShiftData.endTime, scheduleObj.startTime, scheduleObj.endTime) &&
        (scheduleObj.shifts == null || scheduleObj.shifts.some(o => o.enabled && o.name === nextNextNextShiftData.shiftName)))
      .map(scheduleObj => {
        const jobs = jobData.find(jobArr => jobArr.some(o => scheduleObj.jobNumbers.includes(o.jobNumber)));
        scheduleObj.requiredOperators = jobs && jobs[0].requiredOperators ? jobs[0].requiredOperators : 0;
        return scheduleObj;
      });
    
    setCurShiftOperators(currentShiftRunning.sort((a, b) => cmp((a.isCurrent ? 0 : 1), (b.isCurrent ? 0 : 1)) || cmp(a.machineCommonName, b.machineCommonName)));
    setNextShiftOperators(nextShiftRunning.sort((a, b) => cmp((a.isCurrent ? 0 : 1), (b.isCurrent ? 0 : 1)) || cmp(a.machineCommonName, b.machineCommonName)));
    setNextNextShiftOperators(nextNextShiftRunning.sort((a, b) => cmp((a.isCurrent ? 0 : 1), (b.isCurrent ? 0 : 1)) || cmp(a.machineCommonName, b.machineCommonName)));
    setNextNextNextShiftOperators(nextNextNextShiftRunning.sort((a, b) => cmp((a.isCurrent ? 0 : 1), (b.isCurrent ? 0 : 1)) || cmp(a.machineCommonName, b.machineCommonName)));
    setCurShiftTitle(`${currentShiftData.shiftDate} | SHIFT ${currentShiftData.shiftName}`);
    setNextShiftTitle(`${nextShiftData.shiftDate} | SHIFT ${nextShiftData.shiftName}`);
    setNextNextShiftTitle(`${nextNextShiftData.shiftDate} | SHIFT ${nextNextShiftData.shiftName}`);
    setNextNextNextShiftTitle(`${nextNextNextShiftData.shiftDate} | SHIFT ${nextNextNextShiftData.shiftName}`);
  }, [locationData, machineData, locatorFilter, show]);
  
  
  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={() => onHide()}
      className={`modal-content-${colorScheme.toUpperCase()}`}
    >
      <Modal.Header>
        <Modal.Title>
          REQUIRED OPERATORS
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles.modalBody}>
        <h5 style={styles.title}>{`${curShiftTitle} -> ${curShiftOperators.reduce((total, cur) => total + cur.requiredOperators, 0)}`}</h5>
        {curShiftOperators.map((obj, index) =>
          <p
            key={index}
            style={{
              ...styles.text,
              color: obj.isCurrent ? GLOBAL_STYLES.CONSTANTS.orangeColor : null,
            }}
          >
            {`${obj.machineCommonName} | ${obj.jobNumbers.join(' & ')} -> ${obj.requiredOperators}`}
          </p>,
        )}
        <h5 style={styles.title}>{`${nextShiftTitle} -> ${nextShiftOperators.reduce((total, cur) => total + cur.requiredOperators, 0)}`}</h5>
        {nextShiftOperators.map((obj, index) =>
          <p
            key={index}
            style={{
              ...styles.text,
              color: obj.isCurrent ? GLOBAL_STYLES.CONSTANTS.orangeColor : null,
            }}
          >
            {`${obj.machineCommonName} | ${obj.jobNumbers.join(' & ')} -> ${obj.requiredOperators}`}
          </p>,
        )}
        <h5 style={styles.title}>{`${nextNextShiftTitle} -> ${nextNextShiftOperators.reduce((total, cur) => total + cur.requiredOperators, 0)}`}</h5>
        {nextNextShiftOperators.map((obj, index) =>
          <p
            key={index}
            style={{
              ...styles.text,
              color: obj.isCurrent ? GLOBAL_STYLES.CONSTANTS.orangeColor : null,
            }}
          >
            {`${obj.machineCommonName} | ${obj.jobNumbers.join(' & ')} -> ${obj.requiredOperators}`}
          </p>,
        )}
        <h5 style={styles.title}>{`${nextNextNextShiftTitle} -> ${nextNextNextShiftOperators.reduce((total, cur) => total + cur.requiredOperators, 0)}`}</h5>
        {nextNextNextShiftOperators.map((obj, index) =>
          <p
            key={index}
            style={{
              ...styles.text,
              color: obj.isCurrent ? GLOBAL_STYLES.CONSTANTS.orangeColor : null,
            }}
          >
            {`${obj.machineCommonName} | ${obj.jobNumbers.join(' & ')} -> ${obj.requiredOperators}`}
          </p>,
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onHide()}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const styles = {
  title: {
    marginTop: 20,
    marginBottom: 5,
  },
  text: {
    margin: 0,
  },
  modalBody: {
    paddingTop: 0,
  },
};

export default connect(mapStateToProps)(OperatorModal);